// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1KtqC","textarea":"styles_textarea__ol9Vw"};